import { useMemo } from 'react'

import { CustomerDetailsAndAddressesQuery } from '@src/hooks/sharedQueries/useCustomerDetailsAndAddressesQuery/queries/__generated__/CustomerDetailsAndAddressesQuery.graphql-interface'
import { useBasketOutletId } from '@src/hooks/useBasketOutletId'
import { useBasketTotals } from '@src/hooks/useTotals/useBasketTotals'

import { useOutletPageContext } from '../pages/OutletPage/OutletPageContext'

export const useOutletLoyaltyCards = (
  customerDetails: CustomerDetailsAndAddressesQuery | undefined
) => {
  const {
    outletFulfilment: { outlet },
  } = useOutletPageContext()
  const { data: basketTotals } = useBasketTotals()
  const { basketOutletId } = useBasketOutletId()
  const isOutletInBasket = basketOutletId === outlet.id

  const loyaltyCards = useMemo(() => {
    if (isOutletInBasket && basketTotals?.checkoutBasketTotals?.loyaltyCards) {
      return basketTotals.checkoutBasketTotals.loyaltyCards.length
        ? basketTotals.checkoutBasketTotals.loyaltyCards
        : outlet.outletLoyaltyCards
    }

    return (
      customerDetails?.customerDetails.loyaltyCards ?? outlet.outletLoyaltyCards
    )
  }, [
    isOutletInBasket,
    basketTotals,
    customerDetails,
    outlet.outletLoyaltyCards,
  ])

  return { loyaltyCards, isOutletInBasket, basketTotals }
}
